(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.Map = {}));
}(this, (function (exports) { 'use strict';

  function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
    return n;
  }
  function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
  }
  function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
  }
  function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties(e, r) {
    for (var t = 0; t < r.length; t++) {
      var o = r[t];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
  }
  function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
      writable: !1
    }), e;
  }
  function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
  }
  function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(t, "prototype", {
      writable: !1
    }), e && _setPrototypeOf(t, e);
  }
  function _isNativeReflectConstruct() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function () {
      return !!t;
    })();
  }
  function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
      var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;
      try {
        if (i = (t = t.call(r)).next, 0 === l) {
          if (Object(t) !== t) return;
          f = !1;
        } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
      } catch (r) {
        o = !0, n = r;
      } finally {
        try {
          if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
        } finally {
          if (o) throw n;
        }
      }
      return a;
    }
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(t);
  }
  function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
      return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
  }
  function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _unsupportedIterableToArray(r, a) {
    if (r) {
      if ("string" == typeof r) return _arrayLikeToArray(r, a);
      var t = {}.toString.call(r).slice(8, -1);
      return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
  }

  function noop() { }
  function run(fn) {
      return fn();
  }
  function blank_object() {
      return Object.create(null);
  }
  function run_all(fns) {
      fns.forEach(run);
  }
  function is_function(thing) {
      return typeof thing === 'function';
  }
  function safe_not_equal(a, b) {
      return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
  }
  function is_empty(obj) {
      return Object.keys(obj).length === 0;
  }

  function append(target, node) {
      target.appendChild(node);
  }
  function insert(target, node, anchor) {
      target.insertBefore(node, anchor || null);
  }
  function detach(node) {
      node.parentNode.removeChild(node);
  }
  function element(name) {
      return document.createElement(name);
  }
  function svg_element(name) {
      return document.createElementNS('http://www.w3.org/2000/svg', name);
  }
  function text(data) {
      return document.createTextNode(data);
  }
  function space() {
      return text(' ');
  }
  function attr(node, attribute, value) {
      if (value == null)
          node.removeAttribute(attribute);
      else if (node.getAttribute(attribute) !== value)
          node.setAttribute(attribute, value);
  }
  function children(element) {
      return Array.from(element.childNodes);
  }
  function toggle_class(element, name, toggle) {
      element.classList[toggle ? 'add' : 'remove'](name);
  }
  function custom_event(type, detail) {
      const e = document.createEvent('CustomEvent');
      e.initCustomEvent(type, false, false, detail);
      return e;
  }

  let current_component;
  function set_current_component(component) {
      current_component = component;
  }
  function get_current_component() {
      if (!current_component)
          throw new Error('Function called outside component initialization');
      return current_component;
  }
  function beforeUpdate(fn) {
      get_current_component().$$.before_update.push(fn);
  }
  function onMount(fn) {
      get_current_component().$$.on_mount.push(fn);
  }
  function onDestroy(fn) {
      get_current_component().$$.on_destroy.push(fn);
  }
  function createEventDispatcher() {
      const component = get_current_component();
      return (type, detail) => {
          const callbacks = component.$$.callbacks[type];
          if (callbacks) {
              // TODO are there situations where events could be dispatched
              // in a server (non-DOM) environment?
              const event = custom_event(type, detail);
              callbacks.slice().forEach(fn => {
                  fn.call(component, event);
              });
          }
      };
  }

  const dirty_components = [];
  const binding_callbacks = [];
  const render_callbacks = [];
  const flush_callbacks = [];
  const resolved_promise = Promise.resolve();
  let update_scheduled = false;
  function schedule_update() {
      if (!update_scheduled) {
          update_scheduled = true;
          resolved_promise.then(flush);
      }
  }
  function add_render_callback(fn) {
      render_callbacks.push(fn);
  }
  let flushing = false;
  const seen_callbacks = new Set();
  function flush() {
      if (flushing)
          return;
      flushing = true;
      do {
          // first, call beforeUpdate functions
          // and update components
          for (let i = 0; i < dirty_components.length; i += 1) {
              const component = dirty_components[i];
              set_current_component(component);
              update(component.$$);
          }
          set_current_component(null);
          dirty_components.length = 0;
          while (binding_callbacks.length)
              binding_callbacks.pop()();
          // then, once components are updated, call
          // afterUpdate functions. This may cause
          // subsequent updates...
          for (let i = 0; i < render_callbacks.length; i += 1) {
              const callback = render_callbacks[i];
              if (!seen_callbacks.has(callback)) {
                  // ...so guard against infinite loops
                  seen_callbacks.add(callback);
                  callback();
              }
          }
          render_callbacks.length = 0;
      } while (dirty_components.length);
      while (flush_callbacks.length) {
          flush_callbacks.pop()();
      }
      update_scheduled = false;
      flushing = false;
      seen_callbacks.clear();
  }
  function update($$) {
      if ($$.fragment !== null) {
          $$.update();
          run_all($$.before_update);
          const dirty = $$.dirty;
          $$.dirty = [-1];
          $$.fragment && $$.fragment.p($$.ctx, dirty);
          $$.after_update.forEach(add_render_callback);
      }
  }
  const outroing = new Set();
  let outros;
  function group_outros() {
      outros = {
          r: 0,
          c: [],
          p: outros // parent group
      };
  }
  function check_outros() {
      if (!outros.r) {
          run_all(outros.c);
      }
      outros = outros.p;
  }
  function transition_in(block, local) {
      if (block && block.i) {
          outroing.delete(block);
          block.i(local);
      }
  }
  function transition_out(block, local, detach, callback) {
      if (block && block.o) {
          if (outroing.has(block))
              return;
          outroing.add(block);
          outros.c.push(() => {
              outroing.delete(block);
              if (callback) {
                  if (detach)
                      block.d(1);
                  callback();
              }
          });
          block.o(local);
      }
  }
  function create_component(block) {
      block && block.c();
  }
  function mount_component(component, target, anchor, customElement) {
      const { fragment, on_mount, on_destroy, after_update } = component.$$;
      fragment && fragment.m(target, anchor);
      if (!customElement) {
          // onMount happens before the initial afterUpdate
          add_render_callback(() => {
              const new_on_destroy = on_mount.map(run).filter(is_function);
              if (on_destroy) {
                  on_destroy.push(...new_on_destroy);
              }
              else {
                  // Edge case - component was destroyed immediately,
                  // most likely as a result of a binding initialising
                  run_all(new_on_destroy);
              }
              component.$$.on_mount = [];
          });
      }
      after_update.forEach(add_render_callback);
  }
  function destroy_component(component, detaching) {
      const $$ = component.$$;
      if ($$.fragment !== null) {
          run_all($$.on_destroy);
          $$.fragment && $$.fragment.d(detaching);
          // TODO null out other refs, including component.$$ (but need to
          // preserve final state?)
          $$.on_destroy = $$.fragment = null;
          $$.ctx = [];
      }
  }
  function make_dirty(component, i) {
      if (component.$$.dirty[0] === -1) {
          dirty_components.push(component);
          schedule_update();
          component.$$.dirty.fill(0);
      }
      component.$$.dirty[(i / 31) | 0] |= (1 << (i % 31));
  }
  function init(component, options, instance, create_fragment, not_equal, props, dirty = [-1]) {
      const parent_component = current_component;
      set_current_component(component);
      const $$ = component.$$ = {
          fragment: null,
          ctx: null,
          // state
          props,
          update: noop,
          not_equal,
          bound: blank_object(),
          // lifecycle
          on_mount: [],
          on_destroy: [],
          on_disconnect: [],
          before_update: [],
          after_update: [],
          context: new Map(parent_component ? parent_component.$$.context : options.context || []),
          // everything else
          callbacks: blank_object(),
          dirty,
          skip_bound: false
      };
      let ready = false;
      $$.ctx = instance
          ? instance(component, options.props || {}, (i, ret, ...rest) => {
              const value = rest.length ? rest[0] : ret;
              if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
                  if (!$$.skip_bound && $$.bound[i])
                      $$.bound[i](value);
                  if (ready)
                      make_dirty(component, i);
              }
              return ret;
          })
          : [];
      $$.update();
      ready = true;
      run_all($$.before_update);
      // `false` as a special case of no DOM component
      $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
      if (options.target) {
          if (options.hydrate) {
              const nodes = children(options.target);
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              $$.fragment && $$.fragment.l(nodes);
              nodes.forEach(detach);
          }
          else {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              $$.fragment && $$.fragment.c();
          }
          if (options.intro)
              transition_in(component.$$.fragment);
          mount_component(component, options.target, options.anchor, options.customElement);
          flush();
      }
      set_current_component(parent_component);
  }
  /**
   * Base class for Svelte components. Used when dev=false.
   */
  class SvelteComponent {
      $destroy() {
          destroy_component(this, 1);
          this.$destroy = noop;
      }
      $on(type, callback) {
          const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
          callbacks.push(callback);
          return () => {
              const index = callbacks.indexOf(callback);
              if (index !== -1)
                  callbacks.splice(index, 1);
          };
      }
      $set($$props) {
          if (this.$$set && !is_empty($$props)) {
              this.$$.skip_bound = true;
              this.$$set($$props);
              this.$$.skip_bound = false;
          }
      }
  }

  /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/spinner/src/Spinner.svelte generated by Svelte v3.38.2 */

  function create_else_block(ctx) {
  	let svg;
  	let rect;
  	let circle;
  	let animateTransform;

  	return {
  		c() {
  			svg = svg_element("svg");
  			rect = svg_element("rect");
  			circle = svg_element("circle");
  			animateTransform = svg_element("animateTransform");
  			attr(rect, "x", "0");
  			attr(rect, "y", "0");
  			attr(rect, "width", "100");
  			attr(rect, "height", "100");
  			attr(rect, "fill", "none");
  			attr(rect, "class", "bk");
  			attr(animateTransform, "attributeName", "transform");
  			attr(animateTransform, "type", "rotate");
  			attr(animateTransform, "values", "0 50 50;180 50 50;360 50 50;");
  			attr(animateTransform, "keyTimes", "0;0.5;1");
  			attr(animateTransform, "dur", "1s");
  			attr(animateTransform, "repeatCount", "indefinite");
  			attr(animateTransform, "begin", "0s");
  			attr(circle, "cx", "50");
  			attr(circle, "cy", "50");
  			attr(circle, "r", "42.5");
  			attr(circle, "stroke-dasharray", "173.57299411083608 93.46238144429634");
  			attr(circle, "stroke", "currentColor");
  			attr(circle, "fill", "none");
  			attr(circle, "stroke-width", "15");
  			attr(svg, "style", /*_style*/ ctx[0]);
  			attr(svg, "fill", "currentColor");
  			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
  			attr(svg, "viewBox", "0 0 100 100");
  			attr(svg, "preserveAspectRatio", "xMidYMid");
  			attr(svg, "class", "uil-ring");
  		},
  		m(target, anchor) {
  			insert(target, svg, anchor);
  			append(svg, rect);
  			append(svg, circle);
  			append(circle, animateTransform);
  		},
  		p(ctx, dirty) {
  			if (dirty & /*_style*/ 1) {
  				attr(svg, "style", /*_style*/ ctx[0]);
  			}
  		},
  		d(detaching) {
  			if (detaching) detach(svg);
  		}
  	};
  }

  // (2:2) {#if mode === 'printos'}
  function create_if_block(ctx) {
  	let svg;
  	let style;
  	let t;
  	let path0;
  	let path1;
  	let g;
  	let circle;

  	return {
  		c() {
  			svg = svg_element("svg");
  			style = svg_element("style");
  			t = text("@-webkit-keyframes el_3R6WG92ED-_9z4k3l2Lz_Animation{0%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);}100%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);}}@keyframes el_3R6WG92ED-_9z4k3l2Lz_Animation{0%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(0deg) translate(-50px, -67.33000183105469px);}100%{-webkit-transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);transform: translate(50px, 67.33000183105469px) rotate(1080deg) translate(-50px, -67.33000183105469px);}}#el_ztyBp85wH *{-webkit-animation-duration: 3s;animation-duration: 3s;-webkit-animation-iteration-count: infinite;animation-iteration-count: infinite;-webkit-animation-timing-function: cubic-bezier(0, 0, 1, 1);animation-timing-function: cubic-bezier(0, 0, 1, 1);}#el_OK7WH8ppuY{fill: currentColor;}#el_pzIR5oVpeo{fill: currentColor;}#el_3R6WG92ED-{fill: none;stroke: currentColor;stroke-width: 5;}#el_3R6WG92ED-_9z4k3l2Lz{-webkit-animation-name: el_3R6WG92ED-_9z4k3l2Lz_Animation;animation-name: el_3R6WG92ED-_9z4k3l2Lz_Animation;}");
  			path0 = svg_element("path");
  			path1 = svg_element("path");
  			g = svg_element("g");
  			circle = svg_element("circle");
  			attr(path0, "d", "M67,70V64.67l-3.53-.91a14.62,14.62,0,0,0-1.41-3.41L64,57.25l-3.73-3.82-3.13,1.91a21,21,0,0,0-3.43-1.5l-.91-3.51H47.33l-.91,3.51A13,13,0,0,0,43,55.24l-3.13-1.91-3.73,3.82L38,60.25a17.89,17.89,0,0,0-1.51,3.41L33,64.57V70l3.53.91a14.62,14.62,0,0,0,1.41,3.41L36,77.4l3.73,3.82,3.13-1.91a21,21,0,0,0,3.43,1.5l.91,3.52h5.44l.91-3.52A13,13,0,0,0,57,79.41l3.13,1.91L64,77.61,62.06,74.5a17.89,17.89,0,0,0,1.51-3.41ZM49.85,76.7a9.48,9.48,0,1,1,9.58-9.43A9.47,9.47,0,0,1,49.85,76.7Z");
  			attr(path0, "id", "el_OK7WH8ppuY");
  			attr(path1, "d", "M92.5,39.38h0a14,14,0,0,0-3.3-.91A19.08,19.08,0,0,0,78,24.77a18.87,18.87,0,0,0-7.6-1.6,20.32,20.32,0,0,0-5.5.8A24.09,24.09,0,0,0,51.7,9.67a24.54,24.54,0,0,0-9.5-2,24.37,24.37,0,0,0-22,14.4A19.84,19.84,0,0,0,18.9,26h-.2A18.34,18.34,0,0,0,2.1,36.67a17.78,17.78,0,0,0,9.3,23.5,18.62,18.62,0,0,0,6.9,1.5h.2c.3-1.6.7-3.1,1.1-4.6H18.5A12.61,12.61,0,0,1,13.2,56a13.33,13.33,0,0,1-8-12.09,14,14,0,0,1,1.1-5.3,13.37,13.37,0,0,1,12.2-8,10.87,10.87,0,0,1,1.8.1l2.3.3.3-2.3a15.65,15.65,0,0,1,1.4-4.8,19.07,19.07,0,0,1,17.8-11.5A19.34,19.34,0,0,1,49.8,14,19.61,19.61,0,0,1,61,27.48l.6,2.8L64.1,29a14.24,14.24,0,0,1,6.1-1.3,15.07,15.07,0,0,1,5.8,1.2,14.62,14.62,0,0,1,8.8,12l.2,2.3L87.3,43h.6a8.87,8.87,0,0,1,2.7.5,7,7,0,0,1,4.2,6.41,7.43,7.43,0,0,1-6.2,7.2h-7a39,39,0,0,1,1.2,4.6h6.1a11.75,11.75,0,0,0,9.5-7.1,12.7,12.7,0,0,0,1-4.6A11.14,11.14,0,0,0,92.5,39.38Z");
  			attr(path1, "id", "el_pzIR5oVpeo");
  			attr(circle, "cx", "50");
  			attr(circle, "cy", "67.33");
  			attr(circle, "r", "25");
  			attr(circle, "stroke-dasharray", "55");
  			attr(circle, "id", "el_3R6WG92ED-");
  			attr(g, "id", "el_3R6WG92ED-_9z4k3l2Lz");
  			attr(g, "data-animator-group", "true");
  			attr(g, "data-animator-type", "1");
  			attr(svg, "style", /*_style*/ ctx[0]);
  			attr(svg, "id", "el_ztyBp85wH");
  			attr(svg, "data-name", "Layer 1");
  			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
  			attr(svg, "viewBox", "0 0 100 100");
  		},
  		m(target, anchor) {
  			insert(target, svg, anchor);
  			append(svg, style);
  			append(style, t);
  			append(svg, path0);
  			append(svg, path1);
  			append(svg, g);
  			append(g, circle);
  		},
  		p(ctx, dirty) {
  			if (dirty & /*_style*/ 1) {
  				attr(svg, "style", /*_style*/ ctx[0]);
  			}
  		},
  		d(detaching) {
  			if (detaching) detach(svg);
  		}
  	};
  }

  function create_fragment$1(ctx) {
  	let div;

  	function select_block_type(ctx, dirty) {
  		if (/*mode*/ ctx[1] === "printos") return create_if_block;
  		return create_else_block;
  	}

  	let current_block_type = select_block_type(ctx);
  	let if_block = current_block_type(ctx);

  	return {
  		c() {
  			div = element("div");
  			if_block.c();
  			attr(div, "class", "pros-spinner");
  		},
  		m(target, anchor) {
  			insert(target, div, anchor);
  			if_block.m(div, null);
  		},
  		p(ctx, [dirty]) {
  			if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
  				if_block.p(ctx, dirty);
  			} else {
  				if_block.d(1);
  				if_block = current_block_type(ctx);

  				if (if_block) {
  					if_block.c();
  					if_block.m(div, null);
  				}
  			}
  		},
  		i: noop,
  		o: noop,
  		d(detaching) {
  			if (detaching) detach(div);
  			if_block.d();
  		}
  	};
  }

  function instance$1($$self, $$props, $$invalidate) {
  	let { diameter = null } = $$props;
  	let { mode = null } = $$props;
  	let { color = null } = $$props;
  	let { _style = "" } = $$props;
  	let { _diameter = null } = $$props;

  	$$self.$$set = $$props => {
  		if ("diameter" in $$props) $$invalidate(3, diameter = $$props.diameter);
  		if ("mode" in $$props) $$invalidate(1, mode = $$props.mode);
  		if ("color" in $$props) $$invalidate(4, color = $$props.color);
  		if ("_style" in $$props) $$invalidate(0, _style = $$props._style);
  		if ("_diameter" in $$props) $$invalidate(2, _diameter = $$props._diameter);
  	};

  	$$self.$$.update = () => {
  		if ($$self.$$.dirty & /*diameter, _diameter, mode, _style, color*/ 31) {
  			{
  				$$invalidate(2, _diameter = diameter ? Number(diameter) : null);

  				if (!_diameter) {
  					$$invalidate(2, _diameter = mode === "printos" ? 200 : 50);
  				}

  				$$invalidate(0, _style = `height:${_diameter}px;width:${_diameter}px;`);
  				$$invalidate(0, _style += color ? `color:${color};` : `color:#0096d6;`);
  			}
  		}
  	};

  	return [_style, mode, _diameter, diameter, color];
  }

  class Spinner extends SvelteComponent {
  	constructor(options) {
  		super();

  		init(this, options, instance$1, create_fragment$1, safe_not_equal, {
  			diameter: 3,
  			mode: 1,
  			color: 4,
  			_style: 0,
  			_diameter: 2
  		});
  	}
  }

  function styleInject(css, ref) {
    if ( ref === void 0 ) ref = {};
    var insertAt = ref.insertAt;

    if (!css || typeof document === 'undefined') { return; }

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  var css_248z = ".croppie-container {\n    width: 100%;\n    height: 100%;\n}\n\n.croppie-container .cr-image {\n    z-index: -1;\n    position: absolute;\n    top: 0;\n    left: 0;\n    transform-origin: 0 0;\n    max-height: none;\n    max-width: none;\n}\n\n.croppie-container .cr-boundary {\n    position: relative;\n    overflow: hidden;\n    margin: 0 auto;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n}\n\n.croppie-container .cr-viewport,\n.croppie-container .cr-resizer {\n    position: absolute;\n    border: 2px solid #fff;\n    margin: auto;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    box-shadow: 0 0 2000px 2000px rgba(0, 0, 0, 0.5);\n    z-index: 0;\n}\n\n.croppie-container .cr-resizer {\n  z-index: 2;\n  box-shadow: none;\n  pointer-events: none;\n}\n\n.croppie-container .cr-resizer-vertical,\n.croppie-container .cr-resizer-horisontal {\n  position: absolute;\n  pointer-events: all;\n}\n\n.croppie-container .cr-resizer-vertical::after,\n.croppie-container .cr-resizer-horisontal::after {\n    display: block;\n    position: absolute;\n    box-sizing: border-box;\n    border: 1px solid black;\n    background: #fff;\n    width: 10px;\n    height: 10px;\n    content: '';\n}\n\n.croppie-container .cr-resizer-vertical {\n  bottom: -5px;\n  cursor: row-resize;\n  width: 100%;\n  height: 10px;\n}\n\n.croppie-container .cr-resizer-vertical::after {\n    left: 50%;\n    margin-left: -5px;\n}\n\n.croppie-container .cr-resizer-horisontal {\n  right: -5px;\n  cursor: col-resize;\n  width: 10px;\n  height: 100%;\n}\n\n.croppie-container .cr-resizer-horisontal::after {\n    top: 50%;\n    margin-top: -5px;\n}\n\n.croppie-container .cr-original-image {\n    display: none;\n}\n\n.croppie-container .cr-vp-circle {\n    border-radius: 50%;\n}\n\n.croppie-container .cr-overlay {\n    z-index: 1;\n    position: absolute;\n    cursor: move;\n    touch-action: none;\n}\n\n.croppie-container .cr-slider-wrap {\n    width: 75%;\n    margin: 15px auto;\n    text-align: center;\n}\n\n.croppie-result {\n    position: relative;\n    overflow: hidden;\n}\n\n.croppie-result img {\n    position: absolute;\n}\n\n.croppie-container .cr-image,\n.croppie-container .cr-overlay,\n.croppie-container .cr-viewport {\n    -webkit-transform: translateZ(0);\n    -moz-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    transform: translateZ(0);\n}\n\n/*************************************/\n/***** STYLING RANGE INPUT ***********/\n/*************************************/\n/*http://brennaobrien.com/blog/2014/05/style-input-type-range-in-every-browser.html */\n/*************************************/\n\n.cr-slider {\n    -webkit-appearance: none;\n/*removes default webkit styles*/\n\t/*border: 1px solid white; *//*fix for FF unable to apply focus style bug */\n    width: 300px;\n/*required for proper track sizing in FF*/\n    max-width: 100%;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    background-color: transparent;\n}\n\n.cr-slider::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 3px;\n    background: rgba(0, 0, 0, 0.5);\n    border: 0;\n    border-radius: 3px;\n}\n\n.cr-slider::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    border: none;\n    height: 16px;\n    width: 16px;\n    border-radius: 50%;\n    background: #ddd;\n    margin-top: -6px;\n}\n\n.cr-slider:focus {\n    outline: none;\n}\n/*\n.cr-slider:focus::-webkit-slider-runnable-track {\nbackground: #ccc;\n}\n*/\n\n.cr-slider::-moz-range-track {\n    width: 100%;\n    height: 3px;\n    background: rgba(0, 0, 0, 0.5);\n    border: 0;\n    border-radius: 3px;\n}\n\n.cr-slider::-moz-range-thumb {\n    border: none;\n    height: 16px;\n    width: 16px;\n    border-radius: 50%;\n    background: #ddd;\n    margin-top: -6px;\n}\n\n/*hide the outline behind the border*/\n.cr-slider:-moz-focusring {\n    outline: 1px solid white;\n    outline-offset: -1px;\n}\n\n.cr-slider::-ms-track {\n    width: 100%;\n    height: 5px;\n    background: transparent;\n/*remove bg colour from the track, we'll use ms-fill-lower and ms-fill-upper instead */\n\tborder-color: transparent;/*leave room for the larger thumb to overflow with a transparent border */\n\tborder-width: 6px 0;\n\tcolor: transparent;/*remove default tick marks*/\n}\n.cr-slider::-ms-fill-lower {\n\tbackground: rgba(0, 0, 0, 0.5);\n\tborder-radius: 10px;\n}\n.cr-slider::-ms-fill-upper {\n\tbackground: rgba(0, 0, 0, 0.5);\n\tborder-radius: 10px;\n}\n.cr-slider::-ms-thumb {\n\tborder: none;\n\theight: 16px;\n\twidth: 16px;\n\tborder-radius: 50%;\n\tbackground: #ddd;\n\tmargin-top:1px;\n}\n.cr-slider:focus::-ms-fill-lower {\n\tbackground: rgba(0, 0, 0, 0.5);\n}\n.cr-slider:focus::-ms-fill-upper {\n\tbackground: rgba(0, 0, 0, 0.5);\n}\n/*******************************************/\n\n/***********************************/\n/* Rotation Tools */\n/***********************************/\n.cr-rotate-controls {\n\tposition: absolute;\n\tbottom: 5px;\n\tleft: 5px;\n\tz-index: 1;\n}\n.cr-rotate-controls button {\n\tborder: 0;\n\tbackground: none;\n}\n.cr-rotate-controls i:before {\n\tdisplay: inline-block;\n\tfont-style: normal;\n\tfont-weight: 900;\n\tfont-size: 22px;\n}\n.cr-rotate-l i:before {\n\tcontent: '↺';\n}\n.cr-rotate-r i:before {\n\tcontent: '↻';\n}\n";
  styleInject(css_248z);

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, basedir, module) {
  	return module = {
  		path: basedir,
  		exports: {},
  		require: function (path, base) {
  			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
  		}
  	}, fn(module, module.exports), module.exports;
  }

  function commonjsRequire () {
  	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
  }

  var croppie = createCommonjsModule(function (module, exports) {
  /*************************
   * Croppie
   * Copyright 2019
   * Foliotek
   * Version: 2.6.5
   *************************/
  (function (root, factory) {
      if (typeof exports.nodeName !== 'string') {
          // CommonJS
          module.exports = factory();
      } else {
          // Browser globals
          root.Croppie = factory();
      }
  }(typeof self !== 'undefined' ? self : commonjsGlobal, function () {

      /* Polyfills */
      if (typeof Promise !== 'function') {
          /*! promise-polyfill 3.1.0 */
          !function(a){function b(a,b){return function(){a.apply(b,arguments);}}function c(a){if("object"!==typeof this)throw new TypeError("Promises must be constructed via new");if("function"!==typeof a)throw new TypeError("not a function");this._state=null,this._value=null,this._deferreds=[],i(a,b(e,this),b(f,this));}function d(a){var b=this;return null===this._state?void this._deferreds.push(a):void k(function(){var c=b._state?a.onFulfilled:a.onRejected;if(null===c)return void(b._state?a.resolve:a.reject)(b._value);var d;try{d=c(b._value);}catch(e){return void a.reject(e)}a.resolve(d);})}function e(a){try{if(a===this)throw new TypeError("A promise cannot be resolved with itself.");if(a&&("object"===typeof a||"function"===typeof a)){var c=a.then;if("function"===typeof c)return void i(b(c,a),b(e,this),b(f,this))}this._state=!0,this._value=a,g.call(this);}catch(d){f.call(this,d);}}function f(a){this._state=!1,this._value=a,g.call(this);}function g(){for(var a=0,b=this._deferreds.length;b>a;a++)d.call(this,this._deferreds[a]);this._deferreds=null;}function h(a,b,c,d){this.onFulfilled="function"===typeof a?a:null,this.onRejected="function"===typeof b?b:null,this.resolve=c,this.reject=d;}function i(a,b,c){var d=!1;try{a(function(a){d||(d=!0,b(a));},function(a){d||(d=!0,c(a));});}catch(e){if(d)return;d=!0,c(e);}}var j=setTimeout,k="function"===typeof setImmediate&&setImmediate||function(a){j(a,1);},l=Array.isArray||function(a){return "[object Array]"===Object.prototype.toString.call(a)};c.prototype["catch"]=function(a){return this.then(null,a)},c.prototype.then=function(a,b){var e=this;return new c(function(c,f){d.call(e,new h(a,b,c,f));})},c.all=function(){var a=Array.prototype.slice.call(1===arguments.length&&l(arguments[0])?arguments[0]:arguments);return new c(function(b,c){function d(f,g){try{if(g&&("object"===typeof g||"function"===typeof g)){var h=g.then;if("function"===typeof h)return void h.call(g,function(a){d(f,a);},c)}a[f]=g,0===--e&&b(a);}catch(i){c(i);}}if(0===a.length)return b([]);for(var e=a.length,f=0;f<a.length;f++)d(f,a[f]);})},c.resolve=function(a){return a&&"object"===typeof a&&a.constructor===c?a:new c(function(b){b(a);})},c.reject=function(a){return new c(function(b,c){c(a);})},c.race=function(a){return new c(function(b,c){for(var d=0,e=a.length;e>d;d++)a[d].then(b,c);})},c._setImmediateFn=function(a){k=a;},module.exports?module.exports=c:a.Promise||(a.Promise=c);}(this);
      }

      if (typeof window !== 'undefined' && typeof window.CustomEvent !== "function") {
          (function(){
              function CustomEvent ( event, params ) {
                  params = params || { bubbles: false, cancelable: false, detail: undefined };
                  var evt = document.createEvent( 'CustomEvent' );
                  evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
                  return evt;
              }
              CustomEvent.prototype = window.Event.prototype;
              window.CustomEvent = CustomEvent;
          }());
      }

      if (typeof HTMLCanvasElement !== 'undefined' && !HTMLCanvasElement.prototype.toBlob) {
          Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
              value: function (callback, type, quality) {
                  var binStr = atob( this.toDataURL(type, quality).split(',')[1] ),
                  len = binStr.length,
                  arr = new Uint8Array(len);

                  for (var i=0; i<len; i++ ) {
                      arr[i] = binStr.charCodeAt(i);
                  }

                  callback( new Blob( [arr], {type: type || 'image/png'} ) );
              }
          });
      }
      /* End Polyfills */

      var cssPrefixes = ['Webkit', 'Moz', 'ms'],
          emptyStyles = typeof document !== 'undefined' ? document.createElement('div').style : {},
          EXIF_NORM = [1,8,3,6],
          EXIF_FLIP = [2,7,4,5],
          CSS_TRANS_ORG,
          CSS_TRANSFORM,
          CSS_USERSELECT;

      function vendorPrefix(prop) {
          if (prop in emptyStyles) {
              return prop;
          }

          var capProp = prop[0].toUpperCase() + prop.slice(1),
              i = cssPrefixes.length;

          while (i--) {
              prop = cssPrefixes[i] + capProp;
              if (prop in emptyStyles) {
                  return prop;
              }
          }
      }

      CSS_TRANSFORM = vendorPrefix('transform');
      CSS_TRANS_ORG = vendorPrefix('transformOrigin');
      CSS_USERSELECT = vendorPrefix('userSelect');

      function getExifOffset(ornt, rotate) {
          var arr = EXIF_NORM.indexOf(ornt) > -1 ? EXIF_NORM : EXIF_FLIP,
              index = arr.indexOf(ornt),
              offset = (rotate / 90) % arr.length;// 180 = 2%4 = 2 shift exif by 2 indexes

          return arr[(arr.length + index + (offset % arr.length)) % arr.length];
      }

      // Credits to : Andrew Dupont - http://andrewdupont.net/2009/08/28/deep-extending-objects-in-javascript/
      function deepExtend(destination, source) {
          destination = destination || {};
          for (var property in source) {
              if (source[property] && source[property].constructor && source[property].constructor === Object) {
                  destination[property] = destination[property] || {};
                  deepExtend(destination[property], source[property]);
              } else {
                  destination[property] = source[property];
              }
          }
          return destination;
      }

      function clone(object) {
          return deepExtend({}, object);
      }

      function debounce(func, wait, immediate) {
          var timeout;
          return function () {
              var context = this, args = arguments;
              var later = function () {
                  timeout = null;
                  if (!immediate) func.apply(context, args);
              };
              var callNow = immediate && !timeout;
              clearTimeout(timeout);
              timeout = setTimeout(later, wait);
              if (callNow) func.apply(context, args);
          };
      }

      function dispatchChange(element) {
          if ("createEvent" in document) {
              var evt = document.createEvent("HTMLEvents");
              evt.initEvent("change", false, true);
              element.dispatchEvent(evt);
          }
          else {
              element.fireEvent("onchange");
          }
      }

      //http://jsperf.com/vanilla-css
      function css(el, styles, val) {
          if (typeof (styles) === 'string') {
              var tmp = styles;
              styles = {};
              styles[tmp] = val;
          }

          for (var prop in styles) {
              el.style[prop] = styles[prop];
          }
      }

      function addClass(el, c) {
          if (el.classList) {
              el.classList.add(c);
          }
          else {
              el.className += ' ' + c;
          }
      }

      function removeClass(el, c) {
          if (el.classList) {
              el.classList.remove(c);
          }
          else {
              el.className = el.className.replace(c, '');
          }
      }

      function setAttributes(el, attrs) {
          for (var key in attrs) {
              el.setAttribute(key, attrs[key]);
          }
      }

      function num(v) {
          return parseInt(v, 10);
      }

      /* Utilities */
      function loadImage(src, doExif) {
          if (!src) { throw 'Source image missing'; }
          
          var img = new Image();
          img.style.opacity = '0';
          return new Promise(function (resolve, reject) {
              function _resolve() {
                  img.style.opacity = '1';
                  setTimeout(function () {
                      resolve(img);
                  }, 1);
              }

              img.removeAttribute('crossOrigin');
              if (src.match(/^https?:\/\/|^\/\//)) {
                  img.setAttribute('crossOrigin', 'anonymous');
              }

              img.onload = function () {
                  if (doExif) {
                      EXIF.getData(img, function () {
                          _resolve();
                      });
                  }
                  else {
                      _resolve();
                  }
              };
              img.onerror = function (ev) {
                  img.style.opacity = 1;
                  setTimeout(function () {
                      reject(ev);
                  }, 1);
              };
              img.src = src;
          });
      }

      function naturalImageDimensions(img, ornt) {
          var w = img.naturalWidth;
          var h = img.naturalHeight;
          var orient = ornt || getExifOrientation(img);
          if (orient && orient >= 5) {
              var x= w;
              w = h;
              h = x;
          }
          return { width: w, height: h };
      }

      /* CSS Transform Prototype */
      var TRANSLATE_OPTS = {
          'translate3d': {
              suffix: ', 0px'
          },
          'translate': {
              suffix: ''
          }
      };
      var Transform = function (x, y, scale) {
          this.x = parseFloat(x);
          this.y = parseFloat(y);
          this.scale = parseFloat(scale);
      };

      Transform.parse = function (v) {
          if (v.style) {
              return Transform.parse(v.style[CSS_TRANSFORM]);
          }
          else if (v.indexOf('matrix') > -1 || v.indexOf('none') > -1) {
              return Transform.fromMatrix(v);
          }
          else {
              return Transform.fromString(v);
          }
      };

      Transform.fromMatrix = function (v) {
          var vals = v.substring(7).split(',');
          if (!vals.length || v === 'none') {
              vals = [1, 0, 0, 1, 0, 0];
          }

          return new Transform(num(vals[4]), num(vals[5]), parseFloat(vals[0]));
      };

      Transform.fromString = function (v) {
          var values = v.split(') '),
              translate = values[0].substring(Croppie.globals.translate.length + 1).split(','),
              scale = values.length > 1 ? values[1].substring(6) : 1,
              x = translate.length > 1 ? translate[0] : 0,
              y = translate.length > 1 ? translate[1] : 0;

          return new Transform(x, y, scale);
      };

      Transform.prototype.toString = function () {
          var suffix = TRANSLATE_OPTS[Croppie.globals.translate].suffix || '';
          return Croppie.globals.translate + '(' + this.x + 'px, ' + this.y + 'px' + suffix + ') scale(' + this.scale + ')';
      };

      var TransformOrigin = function (el) {
          if (!el || !el.style[CSS_TRANS_ORG]) {
              this.x = 0;
              this.y = 0;
              return;
          }
          var css = el.style[CSS_TRANS_ORG].split(' ');
          this.x = parseFloat(css[0]);
          this.y = parseFloat(css[1]);
      };

      TransformOrigin.prototype.toString = function () {
          return this.x + 'px ' + this.y + 'px';
      };

      function getExifOrientation (img) {
          return img.exifdata && img.exifdata.Orientation ? num(img.exifdata.Orientation) : 1;
      }

      function drawCanvas(canvas, img, orientation) {
          var width = img.width,
              height = img.height,
              ctx = canvas.getContext('2d');

          canvas.width = img.width;
          canvas.height = img.height;

          ctx.save();
          switch (orientation) {
            case 2:
               ctx.translate(width, 0);
               ctx.scale(-1, 1);
               break;

            case 3:
                ctx.translate(width, height);
                ctx.rotate(180*Math.PI/180);
                break;

            case 4:
                ctx.translate(0, height);
                ctx.scale(1, -1);
                break;

            case 5:
                canvas.width = height;
                canvas.height = width;
                ctx.rotate(90*Math.PI/180);
                ctx.scale(1, -1);
                break;

            case 6:
                canvas.width = height;
                canvas.height = width;
                ctx.rotate(90*Math.PI/180);
                ctx.translate(0, -height);
                break;

            case 7:
                canvas.width = height;
                canvas.height = width;
                ctx.rotate(-90*Math.PI/180);
                ctx.translate(-width, height);
                ctx.scale(1, -1);
                break;

            case 8:
                canvas.width = height;
                canvas.height = width;
                ctx.translate(0, width);
                ctx.rotate(-90*Math.PI/180);
                break;
          }
          ctx.drawImage(img, 0,0, width, height);
          ctx.restore();
      }

      /* Private Methods */
      function _create() {
          var self = this,
              contClass = 'croppie-container',
              customViewportClass = self.options.viewport.type ? 'cr-vp-' + self.options.viewport.type : null,
              boundary, img, viewport, overlay, bw, bh;

          self.options.useCanvas = self.options.enableOrientation || _hasExif.call(self);
          // Properties on class
          self.data = {};
          self.elements = {};

          boundary = self.elements.boundary = document.createElement('div');
          viewport = self.elements.viewport = document.createElement('div');
          img = self.elements.img = document.createElement('img');
          overlay = self.elements.overlay = document.createElement('div');

          if (self.options.useCanvas) {
              self.elements.canvas = document.createElement('canvas');
              self.elements.preview = self.elements.canvas;
          }
          else {
              self.elements.preview = img;
          }

          addClass(boundary, 'cr-boundary');
          boundary.setAttribute('aria-dropeffect', 'none');
          bw = self.options.boundary.width;
          bh = self.options.boundary.height;
          css(boundary, {
              width: (bw + (isNaN(bw) ? '' : 'px')),
              height: (bh + (isNaN(bh) ? '' : 'px'))
          });

          addClass(viewport, 'cr-viewport');
          if (customViewportClass) {
              addClass(viewport, customViewportClass);
          }
          css(viewport, {
              width: self.options.viewport.width + 'px',
              height: self.options.viewport.height + 'px'
          });
          viewport.setAttribute('tabindex', 0);

          addClass(self.elements.preview, 'cr-image');
          setAttributes(self.elements.preview, { 'alt': 'preview', 'aria-grabbed': 'false' });
          addClass(overlay, 'cr-overlay');

          self.element.appendChild(boundary);
          boundary.appendChild(self.elements.preview);
          boundary.appendChild(viewport);
          boundary.appendChild(overlay);

          addClass(self.element, contClass);
          if (self.options.customClass) {
              addClass(self.element, self.options.customClass);
          }

          _initDraggable.call(this);

          if (self.options.enableZoom) {
              _initializeZoom.call(self);
          }

          // if (self.options.enableOrientation) {
          //     _initRotationControls.call(self);
          // }

          if (self.options.enableResize) {
              _initializeResize.call(self);
          }
      }

      // function _initRotationControls () {
      //     var self = this,
      //         wrap, btnLeft, btnRight, iLeft, iRight;

      //     wrap = document.createElement('div');
      //     self.elements.orientationBtnLeft = btnLeft = document.createElement('button');
      //     self.elements.orientationBtnRight = btnRight = document.createElement('button');

      //     wrap.appendChild(btnLeft);
      //     wrap.appendChild(btnRight);

      //     iLeft = document.createElement('i');
      //     iRight = document.createElement('i');
      //     btnLeft.appendChild(iLeft);
      //     btnRight.appendChild(iRight);

      //     addClass(wrap, 'cr-rotate-controls');
      //     addClass(btnLeft, 'cr-rotate-l');
      //     addClass(btnRight, 'cr-rotate-r');

      //     self.elements.boundary.appendChild(wrap);

      //     btnLeft.addEventListener('click', function () {
      //         self.rotate(-90);
      //     });
      //     btnRight.addEventListener('click', function () {
      //         self.rotate(90);
      //     });
      // }

      function _hasExif() {
          return this.options.enableExif && window.EXIF;
      }

      function _initializeResize () {
          var self = this;
          var wrap = document.createElement('div');
          var isDragging = false;
          var direction;
          var originalX;
          var originalY;
          var minSize = 50;
          var maxWidth;
          var maxHeight;
          var vr;
          var hr;

          addClass(wrap, 'cr-resizer');
          css(wrap, {
              width: this.options.viewport.width + 'px',
              height: this.options.viewport.height + 'px'
          });

          if (this.options.resizeControls.height) {
              vr = document.createElement('div');
              addClass(vr, 'cr-resizer-vertical');
              wrap.appendChild(vr);
          }

          if (this.options.resizeControls.width) {
              hr = document.createElement('div');
              addClass(hr, 'cr-resizer-horisontal');
              wrap.appendChild(hr);
          }

          function mouseDown(ev) {
              if (ev.button !== undefined && ev.button !== 0) return;

              ev.preventDefault();
              if (isDragging) {
                  return;
              }

              var overlayRect = self.elements.overlay.getBoundingClientRect();

              isDragging = true;
              originalX = ev.pageX;
              originalY = ev.pageY;
              direction = ev.currentTarget.className.indexOf('vertical') !== -1 ? 'v' : 'h';
              maxWidth = overlayRect.width;
              maxHeight = overlayRect.height;

              if (ev.touches) {
                  var touches = ev.touches[0];
                  originalX = touches.pageX;
                  originalY = touches.pageY;
              }

              window.addEventListener('mousemove', mouseMove);
              window.addEventListener('touchmove', mouseMove);
              window.addEventListener('mouseup', mouseUp);
              window.addEventListener('touchend', mouseUp);
              document.body.style[CSS_USERSELECT] = 'none';
          }

          function mouseMove(ev) {
              var pageX = ev.pageX;
              var pageY = ev.pageY;

              ev.preventDefault();

              if (ev.touches) {
                  var touches = ev.touches[0];
                  pageX = touches.pageX;
                  pageY = touches.pageY;
              }

              var deltaX = pageX - originalX;
              var deltaY = pageY - originalY;
              var newHeight = self.options.viewport.height + deltaY;
              var newWidth = self.options.viewport.width + deltaX;

              if (direction === 'v' && newHeight >= minSize && newHeight <= maxHeight) {
                  css(wrap, {
                      height: newHeight + 'px'
                  });

                  self.options.boundary.height += deltaY;
                  css(self.elements.boundary, {
                      height: self.options.boundary.height + 'px'
                  });

                  self.options.viewport.height += deltaY;
                  css(self.elements.viewport, {
                      height: self.options.viewport.height + 'px'
                  });
              }
              else if (direction === 'h' && newWidth >= minSize && newWidth <= maxWidth) {
                  css(wrap, {
                      width: newWidth + 'px'
                  });

                  self.options.boundary.width += deltaX;
                  css(self.elements.boundary, {
                      width: self.options.boundary.width + 'px'
                  });

                  self.options.viewport.width += deltaX;
                  css(self.elements.viewport, {
                      width: self.options.viewport.width + 'px'
                  });
              }

              _updateOverlay.call(self);
              _updateZoomLimits.call(self);
              _updateCenterPoint.call(self);
              _triggerUpdate.call(self);
              originalY = pageY;
              originalX = pageX;
          }

          function mouseUp() {
              isDragging = false;
              window.removeEventListener('mousemove', mouseMove);
              window.removeEventListener('touchmove', mouseMove);
              window.removeEventListener('mouseup', mouseUp);
              window.removeEventListener('touchend', mouseUp);
              document.body.style[CSS_USERSELECT] = '';
          }

          if (vr) {
              vr.addEventListener('mousedown', mouseDown);
              vr.addEventListener('touchstart', mouseDown);
          }

          if (hr) {
              hr.addEventListener('mousedown', mouseDown);
              hr.addEventListener('touchstart', mouseDown);
          }

          this.elements.boundary.appendChild(wrap);
      }

      function _setZoomerVal(v) {
          if (this.options.enableZoom) {
              var z = this.elements.zoomer,
                  val = fix(v, 4);

              z.value = Math.max(parseFloat(z.min), Math.min(parseFloat(z.max), val)).toString();
          }
      }

      function _initializeZoom() {
          var self = this,
              wrap = self.elements.zoomerWrap = document.createElement('div'),
              zoomer = self.elements.zoomer = document.createElement('input');

          addClass(wrap, 'cr-slider-wrap');
          addClass(zoomer, 'cr-slider');
          zoomer.type = 'range';
          zoomer.step = '0.0001';
          zoomer.value = '1';
          zoomer.style.display = self.options.showZoomer ? '' : 'none';
          zoomer.setAttribute('aria-label', 'zoom');

          self.element.appendChild(wrap);
          wrap.appendChild(zoomer);

          self._currentZoom = 1;

          function change() {
              _onZoom.call(self, {
                  value: parseFloat(zoomer.value),
                  origin: new TransformOrigin(self.elements.preview),
                  viewportRect: self.elements.viewport.getBoundingClientRect(),
                  transform: Transform.parse(self.elements.preview)
              });
          }

          function scroll(ev) {
              var delta, targetZoom;

              if(self.options.mouseWheelZoom === 'ctrl' && ev.ctrlKey !== true){
                return 0;
              } else if (ev.wheelDelta) {
                  delta = ev.wheelDelta / 1200; //wheelDelta min: -120 max: 120 // max x 10 x 2
              } else if (ev.deltaY) {
                  delta = ev.deltaY / 1060; //deltaY min: -53 max: 53 // max x 10 x 2
              } else if (ev.detail) {
                  delta = ev.detail / -60; //delta min: -3 max: 3 // max x 10 x 2
              } else {
                  delta = 0;
              }

              targetZoom = self._currentZoom + (delta * self._currentZoom);

              ev.preventDefault();
              _setZoomerVal.call(self, targetZoom);
              change.call(self);
          }

          self.elements.zoomer.addEventListener('input', change);// this is being fired twice on keypress
          self.elements.zoomer.addEventListener('change', change);

          if (self.options.mouseWheelZoom) {
              self.elements.boundary.addEventListener('mousewheel', scroll);
              self.elements.boundary.addEventListener('DOMMouseScroll', scroll);
          }
      }

      function _onZoom(ui) {
          var self = this,
              transform = ui ? ui.transform : Transform.parse(self.elements.preview),
              vpRect = ui ? ui.viewportRect : self.elements.viewport.getBoundingClientRect(),
              origin = ui ? ui.origin : new TransformOrigin(self.elements.preview);

          function applyCss() {
              var transCss = {};
              transCss[CSS_TRANSFORM] = transform.toString();
              transCss[CSS_TRANS_ORG] = origin.toString();
              css(self.elements.preview, transCss);
          }

          self._currentZoom = ui ? ui.value : self._currentZoom;
          transform.scale = self._currentZoom;
          self.elements.zoomer.setAttribute('aria-valuenow', self._currentZoom);
          applyCss();

          if (self.options.enforceBoundary) {
              var boundaries = _getVirtualBoundaries.call(self, vpRect),
                  transBoundaries = boundaries.translate,
                  oBoundaries = boundaries.origin;

              if (transform.x >= transBoundaries.maxX) {
                  origin.x = oBoundaries.minX;
                  transform.x = transBoundaries.maxX;
              }

              if (transform.x <= transBoundaries.minX) {
                  origin.x = oBoundaries.maxX;
                  transform.x = transBoundaries.minX;
              }

              if (transform.y >= transBoundaries.maxY) {
                  origin.y = oBoundaries.minY;
                  transform.y = transBoundaries.maxY;
              }

              if (transform.y <= transBoundaries.minY) {
                  origin.y = oBoundaries.maxY;
                  transform.y = transBoundaries.minY;
              }
          }
          applyCss();
          _debouncedOverlay.call(self);
          _triggerUpdate.call(self);
      }

      function _getVirtualBoundaries(viewport) {
          var self = this,
              scale = self._currentZoom,
              vpWidth = viewport.width,
              vpHeight = viewport.height,
              centerFromBoundaryX = self.elements.boundary.clientWidth / 2,
              centerFromBoundaryY = self.elements.boundary.clientHeight / 2,
              imgRect = self.elements.preview.getBoundingClientRect(),
              curImgWidth = imgRect.width,
              curImgHeight = imgRect.height,
              halfWidth = vpWidth / 2,
              halfHeight = vpHeight / 2;

          var maxX = ((halfWidth / scale) - centerFromBoundaryX) * -1;
          var minX = maxX - ((curImgWidth * (1 / scale)) - (vpWidth * (1 / scale)));

          var maxY = ((halfHeight / scale) - centerFromBoundaryY) * -1;
          var minY = maxY - ((curImgHeight * (1 / scale)) - (vpHeight * (1 / scale)));

          var originMinX = (1 / scale) * halfWidth;
          var originMaxX = (curImgWidth * (1 / scale)) - originMinX;

          var originMinY = (1 / scale) * halfHeight;
          var originMaxY = (curImgHeight * (1 / scale)) - originMinY;

          return {
              translate: {
                  maxX: maxX,
                  minX: minX,
                  maxY: maxY,
                  minY: minY
              },
              origin: {
                  maxX: originMaxX,
                  minX: originMinX,
                  maxY: originMaxY,
                  minY: originMinY
              }
          };
      }

      function _updateCenterPoint(rotate) {
          var self = this,
              scale = self._currentZoom,
              data = self.elements.preview.getBoundingClientRect(),
              vpData = self.elements.viewport.getBoundingClientRect(),
              transform = Transform.parse(self.elements.preview.style[CSS_TRANSFORM]),
              pc = new TransformOrigin(self.elements.preview),
              top = (vpData.top - data.top) + (vpData.height / 2),
              left = (vpData.left - data.left) + (vpData.width / 2),
              center = {},
              adj = {};

          if (rotate) {
              var cx = pc.x;
              var cy = pc.y;
              var tx = transform.x;
              var ty = transform.y;

              center.y = cx;
              center.x = cy;
              transform.y = tx;
              transform.x = ty;
          }
          else {
              center.y = top / scale;
              center.x = left / scale;

              adj.y = (center.y - pc.y) * (1 - scale);
              adj.x = (center.x - pc.x) * (1 - scale);

              transform.x -= adj.x;
              transform.y -= adj.y;
          }

          var newCss = {};
          newCss[CSS_TRANS_ORG] = center.x + 'px ' + center.y + 'px';
          newCss[CSS_TRANSFORM] = transform.toString();
          css(self.elements.preview, newCss);
      }

      function _initDraggable() {
          var self = this,
              isDragging = false,
              originalX,
              originalY,
              originalDistance,
              vpRect,
              transform;

          function assignTransformCoordinates(deltaX, deltaY) {
              var imgRect = self.elements.preview.getBoundingClientRect(),
                  top = transform.y + deltaY,
                  left = transform.x + deltaX;

              if (self.options.enforceBoundary) {
                  if (vpRect.top > imgRect.top + deltaY && vpRect.bottom < imgRect.bottom + deltaY) {
                      transform.y = top;
                  }

                  if (vpRect.left > imgRect.left + deltaX && vpRect.right < imgRect.right + deltaX) {
                      transform.x = left;
                  }
              }
              else {
                  transform.y = top;
                  transform.x = left;
              }
          }

          function toggleGrabState(isDragging) {
            self.elements.preview.setAttribute('aria-grabbed', isDragging);
            self.elements.boundary.setAttribute('aria-dropeffect', isDragging? 'move': 'none');
          }

          function keyDown(ev) {
              var LEFT_ARROW  = 37,
                  UP_ARROW    = 38,
                  RIGHT_ARROW = 39,
                  DOWN_ARROW  = 40;

              if (ev.shiftKey && (ev.keyCode === UP_ARROW || ev.keyCode === DOWN_ARROW)) {
                  var zoom;
                  if (ev.keyCode === UP_ARROW) {
                      zoom = parseFloat(self.elements.zoomer.value) + parseFloat(self.elements.zoomer.step);
                  }
                  else {
                      zoom = parseFloat(self.elements.zoomer.value) - parseFloat(self.elements.zoomer.step);
                  }
                  self.setZoom(zoom);
              }
              else if (self.options.enableKeyMovement && (ev.keyCode >= 37 && ev.keyCode <= 40)) {
                  ev.preventDefault();
                  var movement = parseKeyDown(ev.keyCode);

                  transform = Transform.parse(self.elements.preview);
                  document.body.style[CSS_USERSELECT] = 'none';
                  vpRect = self.elements.viewport.getBoundingClientRect();
                  keyMove(movement);
              }

              function parseKeyDown(key) {
                  switch (key) {
                      case LEFT_ARROW:
                          return [1, 0];
                      case UP_ARROW:
                          return [0, 1];
                      case RIGHT_ARROW:
                          return [-1, 0];
                      case DOWN_ARROW:
                          return [0, -1];
                  }
              }
          }

          function keyMove(movement) {
              var deltaX = movement[0],
                  deltaY = movement[1],
                  newCss = {};

              assignTransformCoordinates(deltaX, deltaY);

              newCss[CSS_TRANSFORM] = transform.toString();
              css(self.elements.preview, newCss);
              _updateOverlay.call(self);
              document.body.style[CSS_USERSELECT] = '';
              _updateCenterPoint.call(self);
              _triggerUpdate.call(self);
              originalDistance = 0;
          }

          function mouseDown(ev) {
              if (ev.button !== undefined && ev.button !== 0) return;

              ev.preventDefault();
              if (isDragging) return;
              isDragging = true;
              originalX = ev.pageX;
              originalY = ev.pageY;

              if (ev.touches) {
                  var touches = ev.touches[0];
                  originalX = touches.pageX;
                  originalY = touches.pageY;
              }
              toggleGrabState(isDragging);
              transform = Transform.parse(self.elements.preview);
              window.addEventListener('mousemove', mouseMove);
              window.addEventListener('touchmove', mouseMove);
              window.addEventListener('mouseup', mouseUp);
              window.addEventListener('touchend', mouseUp);
              document.body.style[CSS_USERSELECT] = 'none';
              vpRect = self.elements.viewport.getBoundingClientRect();
          }

          function mouseMove(ev) {
              ev.preventDefault();
              var pageX = ev.pageX,
                  pageY = ev.pageY;

              if (ev.touches) {
                  var touches = ev.touches[0];
                  pageX = touches.pageX;
                  pageY = touches.pageY;
              }

              var deltaX = pageX - originalX,
                  deltaY = pageY - originalY,
                  newCss = {};

              if (ev.type === 'touchmove') {
                  if (ev.touches.length > 1) {
                      var touch1 = ev.touches[0];
                      var touch2 = ev.touches[1];
                      var dist = Math.sqrt((touch1.pageX - touch2.pageX) * (touch1.pageX - touch2.pageX) + (touch1.pageY - touch2.pageY) * (touch1.pageY - touch2.pageY));

                      if (!originalDistance) {
                          originalDistance = dist / self._currentZoom;
                      }

                      var scale = dist / originalDistance;

                      _setZoomerVal.call(self, scale);
                      dispatchChange(self.elements.zoomer);
                      return;
                  }
              }

              assignTransformCoordinates(deltaX, deltaY);

              newCss[CSS_TRANSFORM] = transform.toString();
              css(self.elements.preview, newCss);
              _updateOverlay.call(self);
              originalY = pageY;
              originalX = pageX;
          }

          function mouseUp() {
              isDragging = false;
              toggleGrabState(isDragging);
              window.removeEventListener('mousemove', mouseMove);
              window.removeEventListener('touchmove', mouseMove);
              window.removeEventListener('mouseup', mouseUp);
              window.removeEventListener('touchend', mouseUp);
              document.body.style[CSS_USERSELECT] = '';
              _updateCenterPoint.call(self);
              _triggerUpdate.call(self);
              originalDistance = 0;
          }

          self.elements.overlay.addEventListener('mousedown', mouseDown);
          self.elements.viewport.addEventListener('keydown', keyDown);
          self.elements.overlay.addEventListener('touchstart', mouseDown);
      }

      function _updateOverlay() {
          if (!this.elements) return; // since this is debounced, it can be fired after destroy
          var self = this,
              boundRect = self.elements.boundary.getBoundingClientRect(),
              imgData = self.elements.preview.getBoundingClientRect();

          css(self.elements.overlay, {
              width: imgData.width + 'px',
              height: imgData.height + 'px',
              top: (imgData.top - boundRect.top) + 'px',
              left: (imgData.left - boundRect.left) + 'px'
          });
      }
      var _debouncedOverlay = debounce(_updateOverlay, 500);

      function _triggerUpdate() {
          var self = this,
              data = self.get();

          if (!_isVisible.call(self)) {
              return;
          }

          self.options.update.call(self, data);
          if (self.$ && typeof Prototype === 'undefined') {
              self.$(self.element).trigger('update.croppie', data);
          }
          else {
              var ev;
              if (window.CustomEvent) {
                  ev = new CustomEvent('update', { detail: data });
              } else {
                  ev = document.createEvent('CustomEvent');
                  ev.initCustomEvent('update', true, true, data);
              }

              self.element.dispatchEvent(ev);
          }
      }

      function _isVisible() {
          return this.elements.preview.offsetHeight > 0 && this.elements.preview.offsetWidth > 0;
      }

      function _updatePropertiesFromImage() {
          var self = this,
              initialZoom = 1,
              cssReset = {},
              img = self.elements.preview,
              imgData,
              transformReset = new Transform(0, 0, initialZoom),
              originReset = new TransformOrigin(),
              isVisible = _isVisible.call(self);

          if (!isVisible || self.data.bound) {// if the croppie isn't visible or it doesn't need binding
              return;
          }

          self.data.bound = true;
          cssReset[CSS_TRANSFORM] = transformReset.toString();
          cssReset[CSS_TRANS_ORG] = originReset.toString();
          cssReset['opacity'] = 1;
          css(img, cssReset);

          imgData = self.elements.preview.getBoundingClientRect();

          self._originalImageWidth = imgData.width;
          self._originalImageHeight = imgData.height;
          self.data.orientation = _hasExif.call(self) ? getExifOrientation(self.elements.img) : self.data.orientation;

          if (self.options.enableZoom) {
              _updateZoomLimits.call(self, true);
          }
          else {
              self._currentZoom = initialZoom;
          }

          transformReset.scale = self._currentZoom;
          cssReset[CSS_TRANSFORM] = transformReset.toString();
          css(img, cssReset);

          if (self.data.points.length) {
              _bindPoints.call(self, self.data.points);
          }
          else {
              _centerImage.call(self);
          }

          _updateCenterPoint.call(self);
          _updateOverlay.call(self);
      }

      function _updateZoomLimits (initial) {
          var self = this,
              minZoom = Math.max(self.options.minZoom, 0) || 0,
              maxZoom = self.options.maxZoom || 1.5,
              initialZoom,
              defaultInitialZoom,
              zoomer = self.elements.zoomer,
              scale = parseFloat(zoomer.value),
              boundaryData = self.elements.boundary.getBoundingClientRect(),
              imgData = naturalImageDimensions(self.elements.img, self.data.orientation),
              vpData = self.elements.viewport.getBoundingClientRect(),
              minW,
              minH;
          if (self.options.enforceBoundary) {
              minW = vpData.width / imgData.width;
              minH = vpData.height / imgData.height;
              minZoom = Math.max(minW, minH);
          }

          if (minZoom >= maxZoom) {
              maxZoom = minZoom + 1;
          }

          zoomer.min = fix(minZoom, 4);
          zoomer.max = fix(maxZoom, 4);

          if (!initial && (scale < zoomer.min || scale > zoomer.max)) {
              _setZoomerVal.call(self, scale < zoomer.min ? zoomer.min : zoomer.max);
          }
          else if (initial) {
              defaultInitialZoom = Math.max((boundaryData.width / imgData.width), (boundaryData.height / imgData.height));
              initialZoom = self.data.boundZoom !== null ? self.data.boundZoom : defaultInitialZoom;
              _setZoomerVal.call(self, initialZoom);
          }

          dispatchChange(zoomer);
      }

      function _bindPoints(points) {
          if (points.length !== 4) {
              throw "Croppie - Invalid number of points supplied: " + points;
          }
          var self = this,
              pointsWidth = points[2] - points[0],
              // pointsHeight = points[3] - points[1],
              vpData = self.elements.viewport.getBoundingClientRect(),
              boundRect = self.elements.boundary.getBoundingClientRect(),
              vpOffset = {
                  left: vpData.left - boundRect.left,
                  top: vpData.top - boundRect.top
              },
              scale = vpData.width / pointsWidth,
              originTop = points[1],
              originLeft = points[0],
              transformTop = (-1 * points[1]) + vpOffset.top,
              transformLeft = (-1 * points[0]) + vpOffset.left,
              newCss = {};

          newCss[CSS_TRANS_ORG] = originLeft + 'px ' + originTop + 'px';
          newCss[CSS_TRANSFORM] = new Transform(transformLeft, transformTop, scale).toString();
          css(self.elements.preview, newCss);

          _setZoomerVal.call(self, scale);
          self._currentZoom = scale;
      }

      function _centerImage() {
          var self = this,
              imgDim = self.elements.preview.getBoundingClientRect(),
              vpDim = self.elements.viewport.getBoundingClientRect(),
              boundDim = self.elements.boundary.getBoundingClientRect(),
              vpLeft = vpDim.left - boundDim.left,
              vpTop = vpDim.top - boundDim.top,
              w = vpLeft - ((imgDim.width - vpDim.width) / 2),
              h = vpTop - ((imgDim.height - vpDim.height) / 2),
              transform = new Transform(w, h, self._currentZoom);

          css(self.elements.preview, CSS_TRANSFORM, transform.toString());
      }

      function _transferImageToCanvas(customOrientation) {
          var self = this,
              canvas = self.elements.canvas,
              img = self.elements.img,
              ctx = canvas.getContext('2d');

          ctx.clearRect(0, 0, canvas.width, canvas.height);
          canvas.width = img.width;
          canvas.height = img.height;

          var orientation = self.options.enableOrientation && customOrientation || getExifOrientation(img);
          drawCanvas(canvas, img, orientation);
      }

      function _getCanvas(data) {
          var self = this,
              points = data.points,
              left = num(points[0]),
              top = num(points[1]),
              right = num(points[2]),
              bottom = num(points[3]),
              width = right-left,
              height = bottom-top,
              circle = data.circle,
              canvas = document.createElement('canvas'),
              ctx = canvas.getContext('2d'),
              canvasWidth = data.outputWidth || width,
              canvasHeight = data.outputHeight || height;

          canvas.width = canvasWidth;
          canvas.height = canvasHeight;

          if (data.backgroundColor) {
              ctx.fillStyle = data.backgroundColor;
              ctx.fillRect(0, 0, canvasWidth, canvasHeight);
          }

          // By default assume we're going to draw the entire
          // source image onto the destination canvas.
          var sx = left,
              sy = top,
              sWidth = width,
              sHeight = height,
              dx = 0,
              dy = 0,
              dWidth = canvasWidth,
              dHeight = canvasHeight;

          //
          // Do not go outside of the original image's bounds along the x-axis.
          // Handle translations when projecting onto the destination canvas.
          //

          // The smallest possible source x-position is 0.
          if (left < 0) {
              sx = 0;
              dx = (Math.abs(left) / width) * canvasWidth;
          }

          // The largest possible source width is the original image's width.
          if (sWidth + sx > self._originalImageWidth) {
              sWidth = self._originalImageWidth - sx;
              dWidth =  (sWidth / width) * canvasWidth;
          }

          //
          // Do not go outside of the original image's bounds along the y-axis.
          //

          // The smallest possible source y-position is 0.
          if (top < 0) {
              sy = 0;
              dy = (Math.abs(top) / height) * canvasHeight;
          }

          // The largest possible source height is the original image's height.
          if (sHeight + sy > self._originalImageHeight) {
              sHeight = self._originalImageHeight - sy;
              dHeight = (sHeight / height) * canvasHeight;
          }

          // console.table({ left, right, top, bottom, canvasWidth, canvasHeight, width, height, startX, startY, circle, sx, sy, dx, dy, sWidth, sHeight, dWidth, dHeight });

          ctx.drawImage(this.elements.preview, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
          if (circle) {
              ctx.fillStyle = '#fff';
              ctx.globalCompositeOperation = 'destination-in';
              ctx.beginPath();
              ctx.arc(canvas.width / 2, canvas.height / 2, canvas.width / 2, 0, Math.PI * 2, true);
              ctx.closePath();
              ctx.fill();
          }
          return canvas;
      }

      function _getHtmlResult(data) {
          var points = data.points,
              div = document.createElement('div'),
              img = document.createElement('img'),
              width = points[2] - points[0],
              height = points[3] - points[1];

          addClass(div, 'croppie-result');
          div.appendChild(img);
          css(img, {
              left: (-1 * points[0]) + 'px',
              top: (-1 * points[1]) + 'px'
          });
          img.src = data.url;
          css(div, {
              width: width + 'px',
              height: height + 'px'
          });

          return div;
      }

      function _getBase64Result(data) {
          return _getCanvas.call(this, data).toDataURL(data.format, data.quality);
      }

      function _getBlobResult(data) {
          var self = this;
          return new Promise(function (resolve) {
              _getCanvas.call(self, data).toBlob(function (blob) {
                  resolve(blob);
              }, data.format, data.quality);
          });
      }

      function _replaceImage(img) {
          if (this.elements.img.parentNode) {
              Array.prototype.forEach.call(this.elements.img.classList, function(c) { img.classList.add(c); });
              this.elements.img.parentNode.replaceChild(img, this.elements.img);
              this.elements.preview = img; // if the img is attached to the DOM, they're not using the canvas
          }
          this.elements.img = img;
      }

      function _bind(options, cb) {
          var self = this,
              url,
              points = [],
              zoom = null,
              hasExif = _hasExif.call(self);

          if (typeof (options) === 'string') {
              url = options;
              options = {};
          }
          else if (Array.isArray(options)) {
              points = options.slice();
          }
          else if (typeof (options) === 'undefined' && self.data.url) { //refreshing
              _updatePropertiesFromImage.call(self);
              _triggerUpdate.call(self);
              return null;
          }
          else {
              url = options.url;
              points = options.points || [];
              zoom = typeof(options.zoom) === 'undefined' ? null : options.zoom;
          }

          self.data.bound = false;
          self.data.url = url || self.data.url;
          self.data.boundZoom = zoom;

          return loadImage(url, hasExif).then(function (img) {
              _replaceImage.call(self, img);
              if (!points.length) {
                  var natDim = naturalImageDimensions(img);
                  var rect = self.elements.viewport.getBoundingClientRect();
                  var aspectRatio = rect.width / rect.height;
                  var imgAspectRatio = natDim.width / natDim.height;
                  var width, height;

                  if (imgAspectRatio > aspectRatio) {
                      height = natDim.height;
                      width = height * aspectRatio;
                  }
                  else {
                      width = natDim.width;
                      height = natDim.height / aspectRatio;
                  }

                  var x0 = (natDim.width - width) / 2;
                  var y0 = (natDim.height - height) / 2;
                  var x1 = x0 + width;
                  var y1 = y0 + height;
                  self.data.points = [x0, y0, x1, y1];
              }
              else if (self.options.relative) {
                  points = [
                      points[0] * img.naturalWidth / 100,
                      points[1] * img.naturalHeight / 100,
                      points[2] * img.naturalWidth / 100,
                      points[3] * img.naturalHeight / 100
                  ];
              }

              self.data.orientation = options.orientation || 1;
              self.data.points = points.map(function (p) {
                  return parseFloat(p);
              });
              if (self.options.useCanvas) {
                  _transferImageToCanvas.call(self, self.data.orientation);
              }
              _updatePropertiesFromImage.call(self);
              _triggerUpdate.call(self);
              cb && cb();
          });
      }

      function fix(v, decimalPoints) {
          return parseFloat(v).toFixed(decimalPoints || 0);
      }

      function _get() {
          var self = this,
              imgData = self.elements.preview.getBoundingClientRect(),
              vpData = self.elements.viewport.getBoundingClientRect(),
              x1 = vpData.left - imgData.left,
              y1 = vpData.top - imgData.top,
              widthDiff = (vpData.width - self.elements.viewport.offsetWidth) / 2, //border
              heightDiff = (vpData.height - self.elements.viewport.offsetHeight) / 2,
              x2 = x1 + self.elements.viewport.offsetWidth + widthDiff,
              y2 = y1 + self.elements.viewport.offsetHeight + heightDiff,
              scale = self._currentZoom;

          if (scale === Infinity || isNaN(scale)) {
              scale = 1;
          }

          var max = self.options.enforceBoundary ? 0 : Number.NEGATIVE_INFINITY;
          x1 = Math.max(max, x1 / scale);
          y1 = Math.max(max, y1 / scale);
          x2 = Math.max(max, x2 / scale);
          y2 = Math.max(max, y2 / scale);

          return {
              points: [fix(x1), fix(y1), fix(x2), fix(y2)],
              zoom: scale,
              orientation: self.data.orientation
          };
      }

      var RESULT_DEFAULTS = {
              type: 'canvas',
              format: 'png',
              quality: 1
          },
          RESULT_FORMATS = ['jpeg', 'webp', 'png'];

      function _result(options) {
          var self = this,
              data = _get.call(self),
              opts = deepExtend(clone(RESULT_DEFAULTS), clone(options)),
              resultType = (typeof (options) === 'string' ? options : (opts.type || 'base64')),
              size = opts.size || 'viewport',
              format = opts.format,
              quality = opts.quality,
              backgroundColor = opts.backgroundColor,
              circle = typeof opts.circle === 'boolean' ? opts.circle : (self.options.viewport.type === 'circle'),
              vpRect = self.elements.viewport.getBoundingClientRect(),
              ratio = vpRect.width / vpRect.height,
              prom;

          if (size === 'viewport') {
              data.outputWidth = vpRect.width;
              data.outputHeight = vpRect.height;
          } else if (typeof size === 'object') {
              if (size.width && size.height) {
                  data.outputWidth = size.width;
                  data.outputHeight = size.height;
              } else if (size.width) {
                  data.outputWidth = size.width;
                  data.outputHeight = size.width / ratio;
              } else if (size.height) {
                  data.outputWidth = size.height * ratio;
                  data.outputHeight = size.height;
              }
          }

          if (RESULT_FORMATS.indexOf(format) > -1) {
              data.format = 'image/' + format;
              data.quality = quality;
          }

          data.circle = circle;
          data.url = self.data.url;
          data.backgroundColor = backgroundColor;

          prom = new Promise(function (resolve) {
              switch(resultType.toLowerCase())
              {
                  case 'rawcanvas':
                      resolve(_getCanvas.call(self, data));
                      break;
                  case 'canvas':
                  case 'base64':
                      resolve(_getBase64Result.call(self, data));
                      break;
                  case 'blob':
                      _getBlobResult.call(self, data).then(resolve);
                      break;
                  default:
                      resolve(_getHtmlResult.call(self, data));
                      break;
              }
          });
          return prom;
      }

      function _refresh() {
          _updatePropertiesFromImage.call(this);
      }

      function _rotate(deg) {
          if (!this.options.useCanvas || !this.options.enableOrientation) {
              throw 'Croppie: Cannot rotate without enableOrientation && EXIF.js included';
          }

          var self = this,
              canvas = self.elements.canvas;

          self.data.orientation = getExifOffset(self.data.orientation, deg);
          drawCanvas(canvas, self.elements.img, self.data.orientation);
          _updateCenterPoint.call(self, true);
          _updateZoomLimits.call(self);

          // Reverses image dimensions if the degrees of rotation is not divisible by 180.
          if ((Math.abs(deg) / 90) % 2 === 1) {
              var oldHeight = self._originalImageHeight;
              var oldWidth = self._originalImageWidth;
              self._originalImageWidth = oldHeight;
              self._originalImageHeight = oldWidth;
          }
      }

      function _destroy() {
          var self = this;
          self.element.removeChild(self.elements.boundary);
          removeClass(self.element, 'croppie-container');
          if (self.options.enableZoom) {
              self.element.removeChild(self.elements.zoomerWrap);
          }
          delete self.elements;
      }

      if (typeof window !== 'undefined' && window.jQuery) {
          var $ = window.jQuery;
          $.fn.croppie = function (opts) {
              var ot = typeof opts;

              if (ot === 'string') {
                  var args = Array.prototype.slice.call(arguments, 1);
                  var singleInst = $(this).data('croppie');

                  if (opts === 'get') {
                      return singleInst.get();
                  }
                  else if (opts === 'result') {
                      return singleInst.result.apply(singleInst, args);
                  }
                  else if (opts === 'bind') {
                      return singleInst.bind.apply(singleInst, args);
                  }

                  return this.each(function () {
                      var i = $(this).data('croppie');
                      if (!i) return;

                      var method = i[opts];
                      if ($.isFunction(method)) {
                          method.apply(i, args);
                          if (opts === 'destroy') {
                              $(this).removeData('croppie');
                          }
                      }
                      else {
                          throw 'Croppie ' + opts + ' method not found';
                      }
                  });
              }
              else {
                  return this.each(function () {
                      var i = new Croppie(this, opts);
                      i.$ = $;
                      $(this).data('croppie', i);
                  });
              }
          };
      }

      function Croppie(element, opts) {
          if (element.className.indexOf('croppie-container') > -1) {
              throw new Error("Croppie: Can't initialize croppie more than once");
          }
          this.element = element;
          this.options = deepExtend(clone(Croppie.defaults), opts);

          if (this.element.tagName.toLowerCase() === 'img') {
              var origImage = this.element;
              addClass(origImage, 'cr-original-image');
              setAttributes(origImage, {'aria-hidden' : 'true', 'alt' : '' });
              var replacementDiv = document.createElement('div');
              this.element.parentNode.appendChild(replacementDiv);
              replacementDiv.appendChild(origImage);
              this.element = replacementDiv;
              this.options.url = this.options.url || origImage.src;
          }

          _create.call(this);
          if (this.options.url) {
              var bindOpts = {
                  url: this.options.url,
                  points: this.options.points
              };
              delete this.options['url'];
              delete this.options['points'];
              _bind.call(this, bindOpts);
          }
      }

      Croppie.defaults = {
          viewport: {
              width: 100,
              height: 100,
              type: 'square'
          },
          boundary: { },
          orientationControls: {
              enabled: true,
              leftClass: '',
              rightClass: ''
          },
          resizeControls: {
              width: true,
              height: true
          },
          customClass: '',
          showZoomer: true,
          enableZoom: true,
          enableResize: false,
          mouseWheelZoom: true,
          enableExif: false,
          enforceBoundary: true,
          enableOrientation: false,
          enableKeyMovement: true,
          update: function () { }
      };

      Croppie.globals = {
          translate: 'translate3d'
      };

      deepExtend(Croppie.prototype, {
          bind: function (options, cb) {
              return _bind.call(this, options, cb);
          },
          get: function () {
              var data = _get.call(this);
              var points = data.points;
              if (this.options.relative) {
                  points[0] /= this.elements.img.naturalWidth / 100;
                  points[1] /= this.elements.img.naturalHeight / 100;
                  points[2] /= this.elements.img.naturalWidth / 100;
                  points[3] /= this.elements.img.naturalHeight / 100;
              }
              return data;
          },
          result: function (type) {
              return _result.call(this, type);
          },
          refresh: function () {
              return _refresh.call(this);
          },
          setZoom: function (v) {
              _setZoomerVal.call(this, v);
              dispatchChange(this.elements.zoomer);
          },
          rotate: function (deg) {
              _rotate.call(this, deg);
          },
          destroy: function () {
              return _destroy.call(this);
          }
      });
      return Croppie;
  }));
  });

  function add_css() {
    var style = element("style");
    style.id = "svelte-1mo00zc-style";
    style.textContent = ".pros-cropper-wrapper.svelte-1mo00zc.svelte-1mo00zc{width:100%;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center}.pros-cropper-wrapper.svelte-1mo00zc .pros-cropper-container.svelte-1mo00zc{flex:1;width:100%}.pros-cropper-wrapper.svelte-1mo00zc .pros-cropper-container.loading.svelte-1mo00zc{display:none}";
    append(document.head, style);
  }

  // (2:2) {#if loading}
  function create_if_block_1(ctx) {
    var spinner;
    var current;
    spinner = new Spinner({
      props: {
        diameter: "24"
      }
    });
    return {
      c: function c() {
        create_component(spinner.$$.fragment);
      },
      m: function m(target, anchor) {
        mount_component(spinner, target, anchor);
        current = true;
      },
      i: function i(local) {
        if (current) return;
        transition_in(spinner.$$.fragment, local);
        current = true;
      },
      o: function o(local) {
        transition_out(spinner.$$.fragment, local);
        current = false;
      },
      d: function d(detaching) {
        destroy_component(spinner, detaching);
      }
    };
  }
  function create_fragment(ctx) {
    var div1;
    var t0;
    var t1;
    var div0;
    var current;
    var if_block0 = /*loading*/ctx[1] && create_if_block_1();
    return {
      c: function c() {
        div1 = element("div");
        if (if_block0) if_block0.c();
        t0 = space();
        t1 = space();
        div0 = element("div");
        attr(div0, "class", "pros-cropper-container svelte-1mo00zc");
        toggle_class(div0, "loading", /*loading*/ctx[1] || error);
        attr(div1, "class", "pros-cropper-wrapper svelte-1mo00zc");
      },
      m: function m(target, anchor) {
        insert(target, div1, anchor);
        if (if_block0) if_block0.m(div1, null);
        append(div1, t0);
        append(div1, t1);
        append(div1, div0);
        /*div0_binding*/
        ctx[10](div0);
        current = true;
      },
      p: function p(ctx, _ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];
        if (/*loading*/ctx[1]) {
          if (if_block0) {
            if (dirty & /*loading*/2) {
              transition_in(if_block0, 1);
            }
          } else {
            if_block0 = create_if_block_1();
            if_block0.c();
            transition_in(if_block0, 1);
            if_block0.m(div1, t0);
          }
        } else if (if_block0) {
          group_outros();
          transition_out(if_block0, 1, 1, function () {
            if_block0 = null;
          });
          check_outros();
        }
        if (dirty & /*loading, error*/2) {
          toggle_class(div0, "loading", /*loading*/ctx[1] || error);
        }
      },
      i: function i(local) {
        if (current) return;
        transition_in(if_block0);
        current = true;
      },
      o: function o(local) {
        transition_out(if_block0);
        current = false;
      },
      d: function d(detaching) {
        if (detaching) detach(div1);
        if (if_block0) if_block0.d();
        /*div0_binding*/
        ctx[10](null);
      }
    };
  }
  var error = false;
  function hasValue(test) {
    return test !== undefined && test !== null;
  }
  function instance($$self, $$props, $$invalidate) {
    createEventDispatcher();
    var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "auto" : _$$props$theme; // Color Theme (auto/dark/light)
    var _$$props$mode = $$props.mode,
      mode = _$$props$mode === void 0 ? "default" : _$$props$mode; // default/form
    var _$$props$className = $$props.className,
      className = _$$props$className === void 0 ? "" : _$$props$className; // Class name
    var _$$props$options = $$props.options,
      options = _$$props$options === void 0 ? {} : _$$props$options;
    var _theme = $$props._theme;
    var _lastTheme = $$props._lastTheme;
    var _className = $$props._className;
    var _cropperElement = $$props._cropperElement;
    var loading = false;
    var _cropper;
    var _inputFile;
    onMount(function () {
      init();
    });
    function init() {
      $$invalidate(4, options.api = {
        setFileSourceAsync: setFileSourceAsync,
        setURLSourceAsync: setURLSourceAsync,
        getResultAsync: getResultAsync
      }, options);
      var promises = [];
      if (options.url) {
        promises.push(setURLSourceAsync(options.url, options.settings));
      } else if (options.file) {
        promises.push(setFileSourceAsync([options.file], options.settings));
      } else {
        promises.push(setFileSourceAsync(null, options.settings));
      }
      return Promise.all(promises)["finally"](function () {
        $$invalidate(1, loading = false);
      });
    }
    function setFileSourceAsync(file, settings) {
      return new Promise(function (resolve, reject) {
        if (_cropper) {
          _cropper.destroy();
          _cropper = null;
        }
        var mySettings = settings ? settings : options;
        _inputFile = file;
        if (_inputFile && _inputFile[0]) {
          var reader = new FileReader();
          reader.onload = function (e) {
            _cropper = new croppie(_cropperElement, mySettings);
            _cropper.bind({
              url: e.target.result
            });
            resolve();
          };
          reader.readAsDataURL(_inputFile[0]);
        }
      });
    }
    function setURLSourceAsync(url, settings) {
      return new Promise(function (resolve, reject) {
        if (_cropper) {
          _cropper.destroy();
          _cropper = null;
        }
        var mySettings = settings ? settings : options;
        _cropper = new croppie(_cropperElement, mySettings);
        _cropper.bind({
          url: url
        });
        resolve();
      });
    }
    function getResultAsync() {
      var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        type: "base64"
      };
      if (!settings.type) {
        settings.type = "base64";
      }
      if (!_cropper) {
        return Promise.resolve(null);
      }
      return _cropper.result(settings);
    }
    beforeUpdate(function () {
      $$invalidate(2, theme = hasValue(theme) ? theme : "light");
      $$invalidate(3, mode = hasValue(mode) ? mode : "icon");
      if (theme !== _lastTheme) {
        $$invalidate(6, _lastTheme = theme);
        if (theme === "auto") {
          var themeAttribute = window.document.body.getAttribute("pos--theme");
          $$invalidate(5, _theme = themeAttribute ? themeAttribute : "light");
          window.removeEventListener("posh-theme-changed", handleThemeChanged);
          window.addEventListener("posh-theme-changed", handleThemeChanged);
        } else {
          $$invalidate(5, _theme = theme);
        }
      }
    });
    onDestroy(function () {
      window.removeEventListener("posh-theme-changed", handleThemeChanged);
    });
    function handleThemeChanged(event) {
      if (theme === "auto") {
        $$invalidate(5, _theme = event.detail.theme);
      }
    }
    function div0_binding($$value) {
      binding_callbacks[$$value ? "unshift" : "push"](function () {
        _cropperElement = $$value;
        $$invalidate(0, _cropperElement);
      });
    }
    $$self.$$set = function ($$props) {
      if ("theme" in $$props) $$invalidate(2, theme = $$props.theme);
      if ("mode" in $$props) $$invalidate(3, mode = $$props.mode);
      if ("className" in $$props) $$invalidate(7, className = $$props.className);
      if ("options" in $$props) $$invalidate(4, options = $$props.options);
      if ("_theme" in $$props) $$invalidate(5, _theme = $$props._theme);
      if ("_lastTheme" in $$props) $$invalidate(6, _lastTheme = $$props._lastTheme);
      if ("_className" in $$props) $$invalidate(8, _className = $$props._className);
      if ("_cropperElement" in $$props) $$invalidate(0, _cropperElement = $$props._cropperElement);
    };
    return [_cropperElement, loading, theme, mode, options, _theme, _lastTheme, className, _className, hasValue, div0_binding];
  }
  var ImageCropper = /*#__PURE__*/function (_SvelteComponent) {
    function ImageCropper(options) {
      var _this;
      _classCallCheck(this, ImageCropper);
      _this = _callSuper(this, ImageCropper);
      if (!document.getElementById("svelte-1mo00zc-style")) add_css();
      init(_this, options, instance, create_fragment, safe_not_equal, {
        theme: 2,
        mode: 3,
        className: 7,
        options: 4,
        _theme: 5,
        _lastTheme: 6,
        _className: 8,
        _cropperElement: 0,
        hasValue: 9
      });
      return _this;
    }
    _inherits(ImageCropper, _SvelteComponent);
    return _createClass(ImageCropper, [{
      key: "hasValue",
      get: function get() {
        return hasValue;
      }
    }]);
  }(SvelteComponent);

  exports.ImageCropper = ImageCropper;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
